











 








const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EndRetrospectiveMutation_notification",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "removedSuggestedActionId",
      "storageKey": null
    }
  ],
  "type": "EndRetrospectiveSuccess",
  "abstractKey": null
};

(node ).hash = "b489ea09f637a656e44f442427d1c368";

export default node;
